export enum CalendarEventStatusEnum {
	SCHEDULED = 'SCHEDULED',
	CANCELLED = 'CANCELLED',
	RESCHEDULED = 'RESCHEDULED',
	CONFIRMED = 'CONFIRMED',
}
